
import Event = createjs.Event;

export class SocialDataEvent extends Event {
    public static SOCIAL_PLAYER_NAME_CHANGED: string = "socialPlayerNameChanged";
    public static LOGIN_KEYS_REFRESHED: string = "loginKeysRefreshed";

    public playerName: string;

    public signatureKey: string;
    public supportKey: string;

    constructor(type: string, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
    }
}

